import { NavLink } from "react-router-dom";

import NavBar from "../navbar";

import './About.css';


const AboutComponent = () => {
    
    return (
        <div>
            <NavBar />
            
            <div id='about-content-main-container'>
                <div id='about-content-container'>
                    <div id='about-content-flex'>
                        <h2>About Me</h2>
                        <p>
                            I am a software engineer based in Oregon with nearly 20 years of hands-on experience building software as a freelancer,
                            hobbyist, and independent developer. My background includes web development, game server tooling, database-backed applications,
                            and long-running projects that required practical problem solving across multiple parts of the stack.
                        </p>
                        
                        <p>
                            Earlier in my career, I worked with a small development team on a custom server and client engine for a 2D MMORPG.
                            I used that toolset to host and maintain my own game, which supported more than 100 daily players. I also built and managed
                            the supporting website and database. That experience gave me a strong foundation in C++, Lua, XML, HTML, CSS, PHP, JavaScript,
                            deployment concerns, and the kind of reliability work that real users depend on.
                        </p>
                        
                        <p>
                            I later completed App Academy's full-time software engineering program, where I spent more than 1,000 hours studying modern
                            full-stack development, engineering best practices, and collaborative project workflows. I bring a practical work ethic, curiosity,
                            and a steady focus on building useful software that is maintainable, thoughtful, and clear.
                        </p>
                        
                        <NavLink id='about-navlink'
                            to='/skills'
                        >View technical skills</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutComponent;
